import usePostData from '../../../../../hooks/postHook';

export const useAddWhitelabelInput = () => {
  const [{ data, body, isLoading, isError, error }, doAddWhitelabelInput] =
    usePostData('parcels/whitelabel_input');

  return { data, body, isLoading, isError, error, doAddWhitelabelInput };
};
